package com.sweetlime.dungeonamigo.util

actual fun currentTimeMillis(): Long = js("Date.now()").unsafeCast<Double>().toLong()